import "./SlateEditorStyles.scss";

import React, { memo } from "react";

import { shortcuts } from "./helpers";

const ShortcutList: React.FC = memo(() => {
  return (
    <div className="editor-shortcuts-container">
      <ul>
        {shortcuts.map((shortcut, index) => (
          <li key={index}>
            <strong>{shortcut.key}</strong> -{" "}
            <span>{shortcut.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
});

export { ShortcutList };
